import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { uniqueId } from "lodash";

import { GET_CONVERSATIONS } from "../../../Queries/ask-vyrill";
import { updateAskVyrillModal, updateAskVyrillState } from "../Actions";
import { getDateString, splitDateRange } from "../../../utilities";
import { RootState } from "../AskVyrillReducer";

import AskBarSearch from "./AskBarSearch";
import AskVyrillDuration from "./AskVyrillDuration";
import SuggestPromptModal from "./SuggestPromptModal";
import { allPrompts } from "../../../constants";
import ModalChatHistory from "./ModalChatHistory";
import "../styles/AskVyrill.scss";
import CustomDateAskVyrill from "./CustomDateAskVyrill";

const customSelectedDateStyles = {
  control: (provided: any) => ({
    ...provided,
    maxWidth: "228px",
    paddingRight: "25px",
    minHeight: "22px",
    backgroundColor: "#f5f7f9",
  }),
  menu: (provided: any) => ({
    ...provided,
    marginTop: "0px",
    width: "228px",
  }),

  dropdownIndicator: (provided: any) => ({
    ...provided,
    position: "absolute",
    right: "2px",
    top: "3px",
  }),
};

const AskVyrillModal = ({ renderFrom }: { renderFrom: string }) => {
  const shouldOpen = useSelector(
    (state: RootState) => state.askVyrill.askVyrillModal.shouldOpen
  );
  // const allPrompts = useSelector(
  //   (state: RootState) => state.askVyrill.allPrompts
  // );
  const askVyrillDuration = useSelector(
    (state: RootState) => state.askVyrill.askVyrillDuration
  );

  const videosCount = useSelector(
    (state: any) => state.navbarStatsReducer.counts.videos
  );
  const currentBrandId = useSelector(
    (state:any) => state.navbarStatsReducer.currentBrand._id
  );
  const allConversations = useSelector(
    (state: RootState) => state.askVyrill?.allConversations
  );

  const [suggestPromptModal, setSuggestPromptModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const { loading, error, data, refetch } = useQuery(GET_ALL_PROMPTS, {
  //   skip: !shouldOpen,
  // });

  const {
    // loading: conversationLoading,
    // error: conversationError,
    // data: conversationData,
    refetch: refetchConversation,
  } = useQuery(GET_CONVERSATIONS, {
    variables: { brandId: currentBrandId },
    skip: true,
  });

  useEffect(() => {
    if (shouldOpen && currentBrandId) {
      dispatch(
        updateAskVyrillState({
          historyLoading: true,
        })
      );

      refetchConversation().then((result) => {
        dispatch(
          updateAskVyrillState({
            allConversations: result?.data?.getConversations,
            historyLoading: false,
          })
        );
      });
    }
  }, [shouldOpen, refetchConversation, currentBrandId]);

  //Unmounting the component action
  useEffect(() => {
    return () => {
      dispatch(
        updateAskVyrillModal({
          requestFrom: "",
          shouldOpen: false,
        })
      );
    };
  }, []);
  const hasConversations = allConversations.length !== 0;

  if (!shouldOpen) return null;
  return (
    <div className={`ask-vyrill-modal ${renderFrom}-page`}>
      <div className="d-flex justify-content-between">
        <div
          className="main-prompt-section"
          style={{
            width: hasConversations ? "1130px" : "1410px",
            borderRadius: hasConversations ? "" : "10px",
          }}

        >
          <div
            style={{
              textAlign: "center",
              fontSize: "16px",
              marginTop: "50px",
              marginBottom: "35px",
              color: "black",
            }}
          >
            <b>Ask Vyrill (Beta)</b>
          </div>
          <div className="prompt-section pb-0">
            <div className="grid-container">
              <div className="action-item">
                <div className="label">
                  <img
                    style={{ width: "18px", height: "18px" }}
                    src={
                      require("@src/assets/images/vyrill/message-prompt.png")
                        .default
                    }
                    alt=""
                  />
                  Prompts
                </div>
              </div>
              <div className="action-item">
                <div className="date-range">
                  <div>Date Range </div>
                  <AskVyrillDuration customStyles={customSelectedDateStyles} />
                  {askVyrillDuration?.value === "custom" && (
                    <CustomDateAskVyrill />
                  )}
                </div>
              </div>
              <div className="action-item">
                <div className="videos-count">
                  <span>
                    Videos-<b> {videosCount}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="prompt-section">
            {/* {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "150px" }}
          >
            <LoadingDots />
          </div>
        ) : ( */}



            <div className="grid-container">
              {allPrompts?.map((k: any) => {
                return (
                  <div
                    key={uniqueId()}
                    onClick={() => {
                      const newQuestion = {
                        content: k.prompt,
                        conversation_id: null,
                        role: "user",
                        duration: askVyrillDuration?.value,
                        start_date: splitDateRange(
                          getDateString(askVyrillDuration?.value)
                        )?.startDate,
                        end_date: splitDateRange(
                          getDateString(askVyrillDuration?.value)
                        )?.endDate,
                      };

                      const curent_time = new Date();
                      const newConversation = {
                        brand_id: currentBrandId,
                        created_at: curent_time,
                        title: k?.prompt,
                        updated_at: curent_time,
                        _id: "newConversation",
                      };

                      navigate(`/ask_vyrill`);
                      dispatch(
                        updateAskVyrillState({
                          messages: [newQuestion],
                          selectedPrompt: k.prompt,
                          messagesLoading: true,
                          isFirstPrompt: true,
                          allConversations: [newConversation, ...allConversations],
                        })
                      );
                    }}
                    className={`grid-item`}
                  >
                    <span>{k.prompt}</span>
                  </div>
                );
              })}
            </div>
            {/* )} */}
          </div>

          <div className="recommended-question">
            {" "}
            <span className="info">
              Ask Vyrill specific questions for better results - e.g.{" "}
              <strong>
                “What are customers saying about the ingredients of Product A?”
              </strong>
            </span>
          </div>

          <SuggestPromptModal
            suggestPromptModal={suggestPromptModal}
            setSuggestPromptModal={setSuggestPromptModal}
          />
          <div className="search-section">
            <AskBarSearch />
          </div>

          <div className="prompt-band">
            <span>
              This feature is under <span style={{ color: "#e62580" }}>Beta</span>{" "}
          testing and may provide inaccurate answers. It is still undergoing
          final testing before its official release.
            </span>
          </div>

        </div>
        <div>
          <span>
            <img
              src={require("@src/assets/images/vyrill/cross.png").default}
              alt=""
              role="button"
              width="38px"
              height="38px"
              className="cross-icon"
              onClick={() => {
                dispatch(
                  updateAskVyrillModal({
                    shouldOpen: false,
                  })
                );
              }}
            />
          </span>
          {allConversations.length !== 0 && <ModalChatHistory />}
        </div>
      </div>
      {/* <span>
        {" "}
        <img
          src={require("@src/assets/images/vyrill/cross.png").default}
          alt=""
          role="button"
          width="38px"
          height="38px"
          className="cross-icon"
          onClick={() => {
            dispatch(
              updateAskVyrillModal({
                shouldOpen: false,
              })
            );
          }}
        />
      </span> */}
      {/* <div
        style={{
          textAlign: "center",
          fontSize: "16px",
          marginTop: "31px",
          color: "black",
        }}
      >
        <b>Ask Vyrill (Beta)</b>
      </div> */}
      {/* 
      <div className="prompt-section pb-0">
        <div className="grid-container">
          <div className="action-item">
            <div className="label">
              <img
                style={{ width: "18px", height: "18px" }}
                src={
                  require("@src/assets/images/vyrill/message-prompt.png")
                    .default
                }
                alt=""
              />
              Prompts
            </div>
          </div>
          <div className="action-item">
            <div className="date-range">
              <div>Date Range </div>
              <AskVyrillDuration customStyles={customSelectedDateStyles} />
            </div>
          </div>
          <div className="action-item">
            <div className="videos-count">
              <span>
                Videos-<b> {videosCount}</b>
              </span>
            </div>
          </div>
        </div>
      </div> */}

   

      {/* <div className="recommended-question">
        {" "}
        <span className="info">
          Ask Vyrill specific questions for better results - e.g.{" "}
          <strong>
            “What are customers saying about the ingredients of Product A?”
          </strong>
        </span>
      </div> */}
      {/* <SuggestPromptModal
        suggestPromptModal={suggestPromptModal}
        setSuggestPromptModal={setSuggestPromptModal}
      />
      <div className="search-section">
        <AskBarSearch />
      </div>

      <div className="prompt-band">
        <span>
          This feature is under <span style={{ color: "#e62580" }}>Beta</span>{" "}
          testing and may provide inaccurate answers. It is still undergoing
          final testing before its official release.
        </span>
      </div> */}
    </div>
  );
};

export default AskVyrillModal;
